import { Component, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash-es';
import { SubNav } from '@core/models/sub-nav.model';
import { SubNavService } from '@core/services';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.less']
})
export class SubHeaderComponent implements OnInit, OnDestroy {

  subNav: SubNav[] = null;
  private subscriptions = new Subscription();

  constructor(
    private subNavService: SubNavService) {

  }

  ngOnInit(): void {
    this.subscriptions.add(this.subNavService.getSubNavOut.subscribe(subnav => {
     this.subNav = subnav;
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  selectedSubNav(subNav: SubNav) {
    this.subNav.forEach(element => {
      if (element.name === subNav.name) {
        element.selected = true;
      } else {
        element.selected = false;
      }
    });
  }

}
